interface CardProps {
  children: React.ReactNode
  className?: string
  padded?: boolean
  onClick?: () => void
}

export default function Card({ children, className = '', padded = true, onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={`bg-card-bg rounded-2xl shadow-lg border border-border ${padded ? 'p-4' : 'p-0'} ${className}`}
    >
      {children}
    </div>
  )
}
